import React from 'react';
import {useEffect, useState} from "react";
import axiosClient from "../axios-client.js";
import swal from 'sweetalert';
import LoadingSpinner from '../components/LoadingSpinner';
import {useStateContext} from "../contexts/ContentProvider";
import {Link, Outlet, useNavigate} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const ComprarClases = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clickEnabled, setClickEnabled] = useState(true);
  const [showFestejoModal, setShowFestejoModal] = useState(false);
  const [pendingPackage, setPendingPackage] = useState(null);
  const {setUser, getUser, setToken, getToken} = useStateContext();
  const token = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    getPackages();
  }, []);

  const getPackages = () => {
    setLoading(true)
    axiosClient.get(token? '/packages-active': '/packages-guest')
      .then(({ data }) => {
        setLoading(false)
        setPackages(data.data)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const addCommasToNumber = (numberString) => {
    const parts = numberString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  const createCheckout = (package_data) => {
    if (!package_data.payment_link || !clickEnabled) return;

    if(!token) {
      swal({
        title: "Sesión / Registro",
        text: "Favor de voler a iniciar sesión o registrate para poder comprar paquetes.",
        closeOnClickOutside: false,
        closeOnEsc: false,
        backdrop: true,
        icon: "warning",
      }).then(() => {
        localStorage.removeItem('ACCESS_TOKEN')
        localStorage.removeItem('USER_DATA')
        navigate('/auth/login')
      });
      return;
    }

    // If festejo, show confirmation modal first
    if (package_data.type === 'festejo') {
      setPendingPackage(package_data);
      setShowFestejoModal(true);
      return;
    }

    proceedToCheckout(package_data);
  };

  const proceedToCheckout = (package_data) => {
    setClickEnabled(false);

    axiosClient.post('/checkout', {
      id: package_data.id,
      product_id: package_data.payment_link
    })
    .then(({data}) => {
      window.location.href = data.url;
    })
    .catch(() => {
      swal({
        title: "Error con el sistema de pagos",
        text: "Una disculpa, favor de contactar al personal para comprar directamente en lo que arreglamos el error",
        icon: "error",
      });
    })
    .finally(() => {
      setClickEnabled(true);
    });
  }

  return (
    <div className='container-fluid packages-page'>
      <div className='container'>
        <h1 className='hero-title mt-5'>Paquetes de clases</h1>
        {/* <p className='package-intro center'>Compra el paquete de clases que más te convenga, ahorra y ¡ejercítate!</p>
        <p className='package-comprar center'>COMPRA TUS CLASES</p> */}
        <p className='center mb-4'>Contamos con <b>TotalPass</b> y <b>Wellhub</b>.</p>
        {loading ? (
          <div className='loading-container center'>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className='packages-container row justify-content-center'>
            {packages.length === 0 ? (
              <p className='text-center'>De momento no tenemos los paquetes listos, favor de intentarlo en otro momento.</p>
            ) : (
              packages.map((p) => {
                const isPopular = (p.num_classes === 15) || (p.num_classes === 17);
                const isPremium = (p.num_classes === 20) || (p.num_classes === 23);
                return (
                  <div className="col-12 col-md-6 col-lg-4" key={p.id}>
                    <div
                      className={`pkg-card ${isPopular ? 'pkg-card--popular' : ''} ${isPremium ? 'pkg-card--premium' : ''} ${clickEnabled ? 'pointer' : 'disabled'}`}
                      onClick={() => createCheckout(p)}
                    >
                      {isPopular && <span className="pkg-badge">Most<br></br>Popular</span>}

                      {p.description && (
                        <p className="pkg-description">{p.description}</p>
                      )}

                      <p className="pkg-price">${addCommasToNumber(p.price)}<sup>00</sup></p>

                      <span className="pkg-name">
                        <span className={isPremium ? 'pkg-name-text' : ''}>{p.name}</span>
                      </span>

                      <p className="pkg-expiration">Vigencia de {p.expiration_days} días.</p>
                    </div>
                  </div>
                );
              })
            )}
            {!clickEnabled && <LoadingSpinner />}
          </div>
        )}

        <Modal show={showFestejoModal} onHide={() => setShowFestejoModal(false)} centered>
          <Modal.Header
            closeButton
            style={{
              background: 'linear-gradient(135deg, rgb(59, 87, 246) 0%, rgb(37, 60, 200) 100%)',
              border: 'none',
            }}
          >
            <Modal.Title style={{ color: '#fff', fontWeight: 'bold' }}>
              🎂 Birthday Ride — ¿Qué incluye?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: '1.5rem 2rem' }}>
            <p style={{ color: 'rgba(255,255,255,0.75)', marginBottom: '1rem', fontSize: '0.9rem' }}>
              ¡Celebra tu cumpleaños pedaleando con tus amigos! Tu paquete incluye:
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1rem 0' }}>
              {[
                'Reserva exclusiva del estudio para ti y tu grupo',
                'Decoración temática de cumpleaños',
                'Playlist personalizada a tu gusto',
                'Instructor dedicado para la sesión',
                'Sesión fotográfica durante la clase',
                'Cortesía de bienvenida para todos los asistentes',
              ].map((item, i) => (
                <li
                  key={i}
                  style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', marginBottom: '0.7rem' }}
                >
                  <span style={{ color: 'rgb(59, 87, 246)', fontWeight: 'bold', flexShrink: 0, fontSize: '1rem' }}>✓</span>
                  <span style={{ color: '#fff', fontSize: '0.9rem' }}>{item}</span>
                </li>
              ))}
            </ul>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '0.75rem' }}>
              <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)', margin: 0 }}>
                Una vez completado el pago, el equipo de Psycle se pondrá en contacto contigo para coordinar los detalles de tu evento.
              </p>
            </div>
          </Modal.Body>

          <Modal.Footer style={{ border: 'none', background: '#1e1e2e', padding: '0.5rem 2rem 1.5rem' }}>
            <Button
              variant="outline-secondary"
              style={{ color: 'rgba(255,255,255,0.6)', borderColor: 'rgba(255,255,255,0.2)', background: 'transparent' }}
              onClick={() => setShowFestejoModal(false)}
            >
              Cancelar
            </Button>
            <Button
              disabled={!clickEnabled}
              style={{
                background: 'linear-gradient(135deg, rgb(59, 87, 246) 0%, rgb(37, 60, 200) 100%)',
                border: 'none',
                fontWeight: 'bold',
                padding: '0.5rem 1.4rem',
                letterSpacing: '0.02em',
              }}
              onClick={() => {
                setShowFestejoModal(false);
                proceedToCheckout(pendingPackage);
              }}
            >
              ¡Sí, quiero celebrar! 🎉
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default ComprarClases;